<template>
  <div>
    <Loading ref="loading" />
  </div>
</template>
<script>
import Loading from '@/components/loading/loading.vue';
// eslint-disable-next-line import/no-cycle
import { whatEev } from '@/utils/tools';
import { getExamDataApi } from '@/api/transition/index';

export default {
  data() {
    return {
      type: null, // 需要过渡的类型
      businessId: null, // 当前类型的id
      productId: null, // 产品id
      productSkuId: null, // productSkuId
      examSource: null, // 考试来源
    };
  },
  components: {
    Loading,
  },
  created() {
    const {
      type, businessId, productId, productSkuId, examSource,
    } = this.$route.query;
    this.productId = productId;
    this.productSkuId = productSkuId;
    this.examSource = examSource;
    this.type = +type;
    this.businessId = +businessId;
    if (whatEev() === 'miniprogram') {
      this.isMiniProgram = true;
      document.title = '';
    }
  },
  watch: {
    type() {
      this.$refs.loading.show = true;
      switch (this.type) {
        case 7:
          this.getExamData();
          break;
        default:
          break;
      }
    },
  },
  mounted() {

  },
  methods: {
    async getExamData() {
      const { code, data } = await getExamDataApi({
        businessLine: 3,
        examId: this.businessId,
      });
      this.$refs.loading.show = false;
      if (code !== 0) {
        this.$toast.fail('参数异常');
      } else {
        const { origin } = window.location;
        if (data.answerInfoId) { // 已经参加过考试
          window.location.replace(`${origin}/mockExam/answerReport?hiddenNavigationBar=1&examId=${this.businessId}&back=close`);
        } else if (this.productId) { // 未参加考试 但是有产品id
          window.location.replace(`${origin}/mockExam/paper?hiddenNavigationBar=1&examId=${this.businessId}&examType=1&productSkuId=${this.productSkuId}&productId=${this.productId}&examSource=${this.examSource}&back=close`);
        } else {
          window.location.replace(`${origin}/mockExam/paper?hiddenNavigationBar=1&examId=${this.businessId}&examType=1&back=close`);
        }
      }
    },
  },
};
// 本页面主要用于过渡页面 比如课表中课后练习跳转至 做题页/结果页 都在本页面判断

</script>
